

































































import Vue from 'vue';
import Component from 'vue-class-component';

import HeaderMenu from '@/components/layout/Header/HeaderMenu.vue';

const Props = Vue.extend({
	props: {
		sticky: {
			type: Boolean,
			default: false
		},
		infosPs: {
			type: Object,
			required: true
		}
	}
});

/** The Header of the application */
@Component({
	components: {
		HeaderMenu
	}
})
export default class Header extends Props {

	get urlRetourEP(): string {
		return this.$cookies.get('ep-origin');
	}
}
